/*! custom-cart-meta.js — "Sabor • Tamanho" nos itens que o JS do tema desenha no carrinho

    O tema mostra sob o nome de cada item os metafields custom.flavor e
    custom.product_size (snippet cart-item-meta), mas so quando a linha vem do
    Liquid. Os itens que o JS insere sem recarregar (COMPRAR na vitrine,
    brindes do BOGOS, qualquer linha nova) so conhecem o /cart.js, que nao
    traz metafields, e ficavam sem essa linha ate um F5.

    Duas fontes, da mais rapida para a mais completa:
    1. o proprio botao COMPRAR da pagina (snippet buy-button) carrega
       data-flavor / data-size do produto: o item "fantasma" que o tema mostra
       na hora do clique, e depois o item real, ganham a linha no mesmo
       instante, sem pedir nada ao servidor;
    2. para o que nao tem botao na pagina (brindes que o app adiciona, itens
       vindos de outra pagina), a secao ep-cart-meta (Section Rendering API)
       devolve a meta de cada linha pelo mesmo snippet do tema. Ela tambem
       confirma a linha provisoria do passo 1 e substitui a meta que o JS do
       tema desenha sozinho (assinatura: ele mostra so o rotulo do plano, sem
       sabor/tamanho). Uma leitura por mudanca, cache por linha e por
       variante, nenhuma escrita. */
(function () {
  'use strict';

  var porLinha = {};    /* key da linha -> HTML canonico ('' = linha sem meta) */
  var porVariante = {}; /* variant_id -> HTML (do botao da pagina ou de uma linha ja vista) */
  var CHAVE = 'ep-cart-meta';

  /* o que ja se viu fica no navegador: brindes que o app adiciona entram na hora da 2a vez em diante */
  try { porVariante = JSON.parse(localStorage.getItem(CHAVE) || '{}') || {}; } catch (e) { porVariante = {}; }
  function guardar() {
    try {
      var chaves = Object.keys(porVariante);
      if (chaves.length > 300) chaves.slice(0, chaves.length - 300).forEach(function (k) { delete porVariante[k]; });
      localStorage.setItem(CHAVE, JSON.stringify(porVariante));
    } catch (e) { /* navegador sem storage: segue so em memoria */ }
  }
  var tentativas = {};  /* key -> pedidos feitos sem a linha vir na resposta */
  var timer = null;
  var lendo = false;
  var pendente = false;

  function escapar(s) {
    return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
  }

  /* mesmo HTML do snippet cart-item-meta, a partir de sabor e tamanho */
  function montar(sabor, tamanho) {
    var partes = [sabor, tamanho].filter(function (v) { return v && String(v).trim(); });
    if (!partes.length) return '';
    return '<div class="cart-item__meta">' + partes.map(function (v, i) {
      return (i ? '<span class="cart-item__meta-separator" aria-hidden="true">•</span>' : '') +
        '<span class="cart-item__meta-item">' + escapar(String(v).trim()) + '</span>';
    }).join('') + '</div>';
  }

  /* variante da linha: key real "variantId:hash"; fantasma "temp-<ts>-<variantId>" */
  function varianteDe(key) {
    if (key.indexOf('temp-') === 0) { var p = key.split('-'); return p.length > 2 ? p[p.length - 1] : ''; }
    return key.split(':')[0];
  }

  /* sabor e tamanho pelo botao COMPRAR presente na pagina */
  function doBotao(variante) {
    if (!variante) return '';
    if (variante in porVariante) return porVariante[variante];
    var b = document.querySelector('buy-button[data-variant-id="' + variante + '"]');
    if (!b || !('flavor' in b.dataset)) return '';
    porVariante[variante] = montar(b.dataset.flavor, b.dataset.size);
    guardar();
    return porVariante[variante];
  }

  function normalizar(html) {
    return String(html || '').replace(/>\s+</g, '><').trim();
  }

  /* a meta sem a parte de assinatura (o rotulo do plano e da linha, nao da variante) */
  function semPlano(meta) {
    var c = meta.cloneNode(true);
    c.querySelectorAll('.cart-item__meta-item--subscription').forEach(function (s) {
      var sep = s.previousElementSibling;
      if (sep && sep.classList.contains('cart-item__meta-separator')) sep.remove();
      s.remove();
    });
    return c.querySelector('.cart-item__meta-item') ? c.outerHTML : '';
  }

  /* provisoria = veio do botao/cache (nao substitui nada que ja exista);
     canonica = veio da secao (substitui a provisoria e a meta que o JS do tema desenhou) */
  function encaixar(el, html, provisoria) {
    var atual = el.querySelector('.cart-item__content > .cart-item__meta');
    if (atual) {
      if (provisoria) return;
      var jsDoTema = el.hasAttribute('data-ep-novo');
      if (!atual.hasAttribute('data-ep-provisoria') && !jsDoTema) return;
      if (html) { if (normalizar(atual.outerHTML) !== normalizar(html)) atual.outerHTML = html; }
      else if (jsDoTema) atual.remove();
      el.removeAttribute('data-ep-novo');
      return;
    }
    if (!provisoria) el.removeAttribute('data-ep-novo');
    if (!html) return;
    var cabecalho = el.querySelector('.cart-item__content > .cart-item__header');
    if (!cabecalho) return;
    cabecalho.insertAdjacentHTML('afterend', html);
    if (provisoria) {
      var novo = el.querySelector('.cart-item__content > .cart-item__meta');
      if (novo) novo.setAttribute('data-ep-provisoria', '');
    }
  }

  /* encaixa o que ja se sabe; devolve as linhas reais que ainda precisam da secao */
  function aplicar() {
    var faltam = [];
    Array.prototype.forEach.call(document.querySelectorAll('cart-item[data-key]'), function (el) {
      var k = el.dataset.key || '';
      if (!k || k === 'temp-cart-item') return;
      var fantasma = k.indexOf('temp-') === 0;
      if (!fantasma && k in porLinha) { encaixar(el, porLinha[k], false); return; }
      encaixar(el, doBotao(varianteDe(k)), true);
      var meta = el.querySelector('.cart-item__content > .cart-item__meta');
      var precisa = !meta || meta.hasAttribute('data-ep-provisoria') || el.hasAttribute('data-ep-novo');
      if (!fantasma && precisa && (tentativas[k] || 0) < 3 && faltam.indexOf(k) < 0) faltam.push(k);
    });
    return faltam;
  }

  function buscar() {
    if (lendo) { pendente = true; return; }
    var faltam = aplicar();
    if (!faltam.length) return;
    lendo = true;
    faltam.forEach(function (k) { tentativas[k] = (tentativas[k] || 0) + 1; });
    fetch('/?section_id=ep-cart-meta', { headers: { Accept: 'text/html' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        doc.querySelectorAll('template[data-key]').forEach(function (t) {
          var meta = t.content.querySelector('.cart-item__meta');
          var k = t.dataset.key;
          porLinha[k] = meta ? meta.outerHTML : '';
          var v = varianteDe(k);
          if (v) porVariante[v] = meta ? semPlano(meta) : '';
        });
        guardar();
        /* linha inserida antes de o servidor a conhecer: tenta de novo daqui a pouco */
        if (aplicar().length) setTimeout(agendar, 1500);
      })
      .catch(function () {})
      .then(function () {
        lendo = false;
        if (pendente) { pendente = false; agendar(); }
      });
  }

  function agendar() {
    clearTimeout(timer);
    timer = setTimeout(buscar, 250);
  }

  /* o tema insere <cart-item> na gaveta e na pagina /cart sem recarregar: o que o botao
     da pagina sabe entra na hora; o resto vai para a fila da secao */
  new MutationObserver(function (lista) {
    var houve = false;
    for (var i = 0; i < lista.length; i++) {
      var add = lista[i].addedNodes;
      for (var j = 0; j < add.length; j++) {
        var n = add[j];
        if (n.nodeName === 'CART-ITEM') { n.setAttribute('data-ep-novo', ''); houve = true; }
        else if (n.nodeName === 'CART-COMPONENT') { n.querySelectorAll('cart-item').forEach(function (c) { c.setAttribute('data-ep-novo', ''); }); houve = true; }
      }
    }
    if (!houve) return;
    aplicar();
    agendar();
  }).observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', agendar);
  else agendar();
})();
